import * as React from 'react'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepSLRAvailableAssets: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>
      What's the total of your savings, retirement accounts, investments, and average of your checking?
    </StepTitle>
    <ApplicationField
      onEnter={props.onEnter}
      onChange={props.handleChangeAndContinue.bind(null, Fields.AvailableAssets)}
      product={Product.Loan}
      field={Fields.AvailableAssets}
    />
  </Wrapper>
)

export default StepbystepApplicationStepSLRAvailableAssets
